import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("cestou_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const imgSrc = (url) => {
  if (!url) return "";
  if (url.startsWith("/api")) return `${BACKEND_URL}${url}`;
  return url;
};

export const BRL = (v) =>
  Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const WA_NUMBER = "5551989975814";

export const waLink = (name, price) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(
    `Olá! Vi no site e quero pedir: ${name} – ${BRL(price)}`
  )}`;

export const WA_MAIN = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(
  "Olá! Vi o site da Cestou Recordações e quero fazer um pedido!"
)}`;

export const INSTAGRAM_URL = "https://instagram.com/cestourecordacoes";
